import FilterChip from 'LuxKit/Chips/FilterChip'
import ModalContext from 'contexts/ModalContext'
import type { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import OfferCalendarAirportModal from './OfferCalendarAirportModal'

interface Props {
  airport?: App.Airport
  activeFilter?: OfferPageFilterType
}

function OfferCalendarAirportSelect(props: Props) {
  const { airport, activeFilter } = props
  const intl = useIntl()

  const showModal = useContext(ModalContext)
  const open = activeFilter === 'airport'

  const onToggleOpen = useCallback(async() => {
    showModal<App.AirportLocation | undefined>(<OfferCalendarAirportModal />)
  }, [showModal])

  const airportLabel = airport
    ? intl.formatMessage(
        {
          id: 'MifUWG6s_qQY2HqUem5-',
          defaultMessage: '{airportName} ({airportCode})',
        },
        { airportName: airport.name, airportCode: airport.code.toUpperCase() },
      )
    : intl.formatMessage({
        id: 'e8V982Tamoh9BARggL60',
        defaultMessage: 'Select by airport',
      })

  return <FilterChip
    size="medium"
    onClick={onToggleOpen}
    selected={open}
  >
    {airportLabel}
  </FilterChip>
}

export default withOfferPageState((state) => ({
  airport: state.airport,
  activeFilter: state.activeSubFilter,
}), OfferCalendarAirportSelect)
